export default __webpack_public_path__ + "static/media/bag24.7f53d9e4.svg";